import React, { forwardRef, useEffect, useRef, useState } from "react";
// import "./FindMember.css";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import InputField from "../StyledComp/InputField";
import MemberServices from "../../services/MemberServices";
import { updateSearchParamFlags } from "../../store/hasSearchParamFlags";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
  Label,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import { updateSearchBody } from "../../store/searchMemberApiSlice";
import DropdownIcon from "../../Images/dropdownIcon";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface state {
  [key: string]: any;
}

interface IProps {
  StateList: state[];
}

const FMFirmAddress: React.FC<IProps> = (props) => {
  const States = props.StateList;
  const dispatch = useDispatch();

  const [divDisplayState, setdivDisplayState] = useState("none");
  let [inputFirmName, setinputFirmName] = useState<any[]>([]);
  const [FirmName, setFirmName] = useState<string | null>();
  const [City, setCity] = useState<string | null>();
  const firmListdivRef = useRef<HTMLDivElement>(null);
  const [isHandleOutsideClickTriggered, setIsHandleOutsideClickTriggered] =
    useState<boolean>(false);

  const [PhoneNumber, setPhoneNumber] = useState<any>(null);
  const [CellPhoneNumber, setCellPhoneNumber] = useState<any>(null);
  const [FaxNumber, setFaxNumber] = useState<any>(null);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  useEffect(() => {
    const getFirmDetailList = async () => {
      console.log("getFirmDetailList called");
      const response = await MemberServices.getFirmDetailList();
      console.log("FirmDetailList response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        setinputFirmName(response.data.data);
        // dispatch(updateMemberList(response.data.data));
      } else {
      }
    };

    getFirmDetailList();
  }, []);

  useEffect(() => {
    console.log(
      "USEEffect called isHandleOutsideClickTriggered:",
      isHandleOutsideClickTriggered
    );
    isHandleOutsideClickTriggered && handleOutsideClick();
  }, [isHandleOutsideClickTriggered]);

  useEffect(() => {
    console.log("USEEffect divDisplayState", isHandleOutsideClickTriggered);

    if (divDisplayState === "block") {
      console.log("EVENT ADDED");
      document.addEventListener("mousedown", updateIsHandleOutsideClickEnabled);
    } else if (divDisplayState === "none") {
      console.log("EVENT REMOVED");
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    }

    // Cleanup to ensure event is removed on unmount or when condition changes
    return () => {
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    };
  }, [divDisplayState]);

  function normalizePhoneNumber(phoneNumber: any) {
    return phoneNumber.replace(/[- )(]/g, "");
  }

  const formatPhoneNumber = (input: any) => {
    if (input == null) {
      return null;
    } else {
      // Remove all non-digit characters
      let numericInputFormatted = input.replace(/\D/g, "");

      // Apply formatting based on length
      if (numericInputFormatted.length > 6) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{3})(\d{0,4})/,
          "($1) $2-$3"
        );
      } else if (numericInputFormatted.length > 3) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{0,3})/,
          "($1) $2"
        );
      } else if (numericInputFormatted.length > 1) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{0,3})/,
          "($1"
        );
      }

      return numericInputFormatted.trim();
    }
  };

  const updateIsHandleOutsideClickEnabled = (event: MouseEvent) => {
    console.log(
      "updateIsHandleOutsideClickEnabled-start",
      isHandleOutsideClickTriggered
    );
    if (
      firmListdivRef.current &&
      !firmListdivRef.current.contains(event.target as Node)
    ) {
      setIsHandleOutsideClickTriggered(true);
    }
    console.log(
      "updateIsHandleOutsideClickEnabled-end",
      isHandleOutsideClickTriggered
    );
  };

  const handleOutsideClick = () => {
    // console.log(firmListdivRef);

    console.log("handleOutsideClick-start:", isHandleOutsideClickTriggered);

    setdivDisplayState("none");

    document.removeEventListener(
      "mousedown",
      updateIsHandleOutsideClickEnabled
    );
    console.log();
    setIsHandleOutsideClickTriggered(false);

    const isFirmNameExists = inputFirmName.find(
      (firmListItem) => firmListItem.FirmName === FirmName
    );

    if (isFirmNameExists === undefined) {
      console.log("isFirmNameExists:", isFirmNameExists);
      console.log("isFirmNameExists-FirmName:", FirmName);
      setFirmName(null);
    } else {
      console.log("FIRM NAME EXIST");
    }
    console.log("handleOutsideClick-end:", isHandleOutsideClickTriggered);
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("updateInput");
    // console.log(event.target.name, " .. ", event.target.value);

    switch (event.target.name) {
      case "City":
        setCity(event.target.value);
        dispatch(
          updateSearchBody({
            key: event.target.name,
            value: event.target.value,
          })
        );
        dispatch(
          updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
        );
        break;
      case "PhoneNumber":
        if (event.target.value.length < 15) {
          const normalizedInput = normalizePhoneNumber(event.target.value);
          const formattedInput = formatPhoneNumber(event.target.value);
          setPhoneNumber(formattedInput);
          dispatch(
            updateSearchBody({
              key: event.target.name,
              value: normalizedInput,
            })
          );
          dispatch(
            updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
          );
        }
        break;
      case "CellPhoneNumber":
        if (event.target.value.length < 15) {
          const normalizedInput = normalizePhoneNumber(event.target.value);
          const formattedInput = formatPhoneNumber(event.target.value);
          setCellPhoneNumber(formattedInput);
          dispatch(
            updateSearchBody({
              key: event.target.name,
              value: normalizedInput,
            })
          );
          dispatch(
            updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
          );
        }
        break;
      case "FaxNumber":
        if (event.target.value.length < 15) {
          const normalizedInput = normalizePhoneNumber(event.target.value);
          const formattedInput = formatPhoneNumber(event.target.value);
          setFaxNumber(formattedInput);
          dispatch(
            updateSearchBody({
              key: event.target.name,
              value: normalizedInput,
            })
          );
          dispatch(
            updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
          );
        }
        break;
      default:
        dispatch(
          updateSearchBody({
            key: event.target.name,
            value: event.target.value,
          })
        );
        dispatch(
          updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
        );
    }
  };
  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log("updateSelectBox", event.target.name, event.target.value);
    dispatch(
      updateSearchBody({ key: event.target.name, value: event.target.value })
    );
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const handleFirmNameClick = (event: any, newFirm: any) => {
    setdivDisplayState("none");
    // const inputValue = event.target.value.trim().toLowerCase();

    // const isFirmNameExists = inputFirmName.some((firmListItem) =>
    //   firmListItem.FirmName.trim().toLowerCase().startsWith(inputValue)
    // );

    // if (isFirmNameExists) {
    //   console.log("isFirmNameExists:Yes", inputValue);
    //
    // } else {
    //   console.log("isFirmNameExists:NO", inputValue);

    // dispatch(updateSearchBody({ key: "FirmId", value: newFirm.Id }));
    dispatch(updateSearchBody({ key: "FirmName", value: newFirm.FirmName }));
    dispatch(updateSearchBody({ key: "City", value: newFirm.City }));
    setFirmName(newFirm.FirmName);
    setCity(newFirm.City);
    console.log("event.target.name:", event.target.name, "-", newFirm.Id);
    // dispatch(updateSearchBody({ key: event.target.name, value: newFirm.Id }));
    dispatch(
      updateSearchParamFlags({ key: "HasOtherSearchParam", value: true })
    );
  };

  const updateFirmInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setFirmName(event.target.value);
  };

  const handleFirmFieldClick = (event: React.MouseEvent<HTMLElement>): void => {
    setdivDisplayState("block");
  };

  return (
    <div className="section-box">
      <h3 className="section-heading">Firm Address</h3>
      <div className="form-wrapper">
        {/* <div className="input-field-div-wrapper">

          <select
            className="dropdown-control-large-insidetextfield"
            // onChange={updateSelectBox}
            id="FirmName"
            name="FirmName"
          >
            <option value=""> Firm Name </option>
            {inputFirmName
              ?.filter((item: any) => {
                return item.FirmName != null;
              })
              .map((item: any) => (
                <option
                  className="suggested-item-row"
                  key={item.Id}
                  onClick={(event) => handleFirmNameClick(event, item)}
                >
                  {item.FirmName}
                  {", "}
                  {item.City}
                </option>
              ))}
          </select>
        </div> */}

        <div
          className="input-field-div-wrapper"
          style={{
            position: "relative",
            borderColor: "var(--active-border-color)",
          }}
        >
          <input
            className="input-field-div-small"
            placeholder=""
            id="FirmName"
            name="FirmName"
            // onChange={updateInput}
            value={typeof FirmName! != "undefined" ? FirmName! : ""}
            disabled={false}
            onChange={updateFirmInput}
            autoComplete="off"
            onClick={handleFirmFieldClick}
          />
          <label className="form-label" htmlFor="FirmName">
            Select Firm Name
          </label>

          <div
            className="suggestion-dropdown"
            style={{
              position: "absolute",
              display: divDisplayState,
              width: "150%",
            }}
            ref={firmListdivRef}
          >
            {inputFirmName
              ?.filter((item: any) => {
                return item.FirmName != null;
              })
              .filter((item: any) => {
                return FirmName
                  ? item.FirmName.toLowerCase().startsWith(
                      FirmName.toLowerCase()
                    )
                  : item.FirmName;
              })
              .map((item: any) => (
                <div
                  className="suggested-item-row"
                  key={item.Id}
                  onClick={(event) => handleFirmNameClick(event, item)}
                >
                  {item.FirmName}
                  {", "}
                  {item.City}
                </div>
              ))}
          </div>
        </div>
        <div className="input-field-div-wrapper">
          {/* <div className="selectfield-label">State</div> */}
          <select
            className="dropdown-control-large-insidetextfield"
            name="State"
            onChange={updateSelectBox}
          >
            <option value="">--States--</option>
            {States?.map((State: any) => (
              <option key={State.Id} value={State.StateName}>
                {State.StateName}
              </option>
            ))}
          </select>
        </div>

        <div className="input-field-div-wrapper">
          <Label>City</Label>
          <input
            className="input-field-div-small"
            id="City"
            name="City"
            placeholder=""
            autoComplete="off"
            onChange={updateInput}
            value={typeof City! != "undefined" ? City! : ""}
          />
          <label className="form-label" htmlFor="City">
            City
          </label>
        </div>

        <div className="input-field-div-wrapper">
          <Label>City</Label>
          <input
            className="input-field-div-small"
            id="County"
            name="County"
            placeholder=""
            autoComplete="off"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="County">
            County
          </label>
        </div>

        <div className="input-field-div-wrapper">
          <Label>Zip Code</Label>
          <input
            className="input-field-div-small"
            placeholder=""
            id="Zipcode"
            name="Zipcode"
            type="number"
            pattern="[0-9]*"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="Zipcode">
            Zip Code
          </label>
        </div>
        <div className="input-field-div-wrapper">
          {/* <Label>Phone Number</Label> */}
          <input
            className="input-field-div-small"
            placeholder=""
            id="PhoneNumber"
            name="PhoneNumber"
            type="text"
            // pattern="[0-9]*"
            onChange={updateInput}
            value={PhoneNumber}
          />
          <label className="form-label" htmlFor="PhoneNumber">
            Phone Number
          </label>
        </div>

        <div className="input-field-div-wrapper">
          {/* <Label>Phone Number</Label> */}
          <input
            className="input-field-div-small"
            placeholder=""
            id="CellPhoneNumber"
            name="CellPhoneNumber"
            type="text"
            // pattern="[0-9]*"
            onChange={updateInput}
            value={CellPhoneNumber}
          />
          <label className="form-label" htmlFor="CellPhoneNumber">
            Cell Phone Number
          </label>
        </div>

        <div className="input-field-div-wrapper">
          {/* <Label>Fax Number</Label> */}
          <input
            className="input-field-div-small"
            placeholder=""
            id="FaxNumber"
            name="FaxNumber"
            type="text"
            // pattern="[0-9]*"
            onChange={updateInput}
            value={FaxNumber}
          />
          <label className="form-label" htmlFor="FaxNumber">
            Fax Number
          </label>
        </div>
        <div className="input-field-div-wrapper">
          {/* <Label>Email ID</Label> */}
          <input
            className="input-field-div-small"
            placeholder=""
            id="Email"
            name="Email"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="Email">
            Email
          </label>
        </div>
        {/* <div className="input-field-div-wrapper">

          <input
            className="input-field-div-small"
            placeholder=""
            id="FirmAdminName"
            name="FirmAdminName"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="FirmAdminName">
            Firm Admin Name
          </label>
        </div>
        <div className="input-field-div-wrapper">
          <Label>Firm Admin Phone Number</Label>
          <input
            className="input-field-div-small"
            placeholder=""
            id="FirmAdminPhoneNumber"
            name="FirmAdminPhoneNumber"
            type="number"
            pattern="[0-9]*"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="FirmAdminPhoneNumber">
            Firm Admin Phone No
          </label>
        </div>
        <div className="input-field-div-wrapper">

          <input
            className="input-field-div-small"
            placeholder=""
            id="FirmAdminEmail"
            name="FirmAdminEmail"
            onChange={updateInput}
          />
          <label className="form-label" htmlFor="FirmAdminEmail">
            Firm Admin Email ID
          </label>
        </div> */}
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FMFirmAddress;
